import { SravniIdentityClientsSubscriptionInfo } from 'src/__generated__/news/Api';

import { IPublicUser } from '@sravni/types/lib/auth';

import { IGlobalState } from '../reducers';

export const getUser = (state: IGlobalState): IPublicUser | null => (state.user.loggedIn ? state.user.account : null);

export const getIsUserLogged = (state: IGlobalState): boolean => state.user.loggedIn;

export const getUserSubscriptions = (state: IGlobalState): SravniIdentityClientsSubscriptionInfo['types'] =>
  state.user.subscription.list;

export const getIsSubscribing = (state: IGlobalState): boolean => state.user.subscription.subscribing;
export const getDidUserSubscribe = (state: IGlobalState): boolean => state.user.subscription.didUserSubscribe;

export const getFingerprint = (state: IGlobalState): string => state.user.fingerprint;

export const getIsSubscriptionPopupVisible = (state: IGlobalState): boolean =>
  state.user.subscription.isSubscriptionPopupVisible;
